import { Component, Input, OnInit } from '@angular/core';
import { IApprovalRoute } from '../models/approval-route.model';
import { CommonModule, DatePipe, NgFor, NgSwitch, TitleCasePipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-approval-route',
  standalone: true,
  imports: [NgFor, MatProgressSpinnerModule, CommonModule, NgSwitch],
  templateUrl: './approval-route.component.html',
  styleUrl: './approval-route.component.scss',
  providers: [DatePipe, TitleCasePipe]
})
export class ApprovalRouteComponent {
  @Input({ required: true }) requestNumber!: number;
  @Input({ required: true }) requestStatus!: number;

  @Input({ required: false }) closedByName?: string;
  @Input({ required: false }) timeClosed?: Date;
  @Input({ required: false }) comment?: string;
  @Input({ required: false }) approvalRouteData?: IApprovalRoute[];
  data: IApprovalRoute[];

  constructor() {}
}
